'use strict';

var React = require('react');
var CompositeIconBase = require('../common/CompositeIconBase');
/**
 * AlarmIcon2
 * 新告警图标
 */
var AlarmIcon2 = React.createClass({
  render: function () {
    return (<CompositeIconBase
      {...this.props}
      borderVisible={this.props.style !== 'ibsNone'}
      alarmVisible={this.props.showAlarm}
      iconVisible={true}
      labelVisible={this.props.showText}>
      {
        this.props.children
      }
    </CompositeIconBase>);
  }
});

module.exports = AlarmIcon2;


// WEBPACK FOOTER //
// ./src/views/Components/AlarmIcon2.jsx